import React, { useEffect, useState } from 'react';
import Card from 'components/Layout/Card';
import Button from 'components/form/Button';
import './InstantPass.scss';
import InstantPassPopup from './InstantPassPopup';
import {
  deleteEventPass,
  fetchInstantPassData,
  handleEventPass,
  showSuccess,
} from 'store/slices';
import { useDispatch } from 'react-redux';
import { generatePreSignedUrl, objectToFormData } from 'utils/helpers';
import { useParams } from 'react-router-dom';
import { passPreview } from 'utils/constants';
import Modal from 'components/Layout/Modal';
import DeletePopup from 'components/Layout/DeletePopup';


const InstantPass = ({ eventId, fetchEventDetails }) => {
  const dispatch = useDispatch();
  //   const params = useParams();
  //   const { eventId } = params;
  const [viewSample, setViewSample] = useState('');
  const [instantPassPopup, setInstantPassPopup] = useState({
    show: false,
  });
  const [htmlContentData, setHtmlContentData] = useState('');
  const [certificateImg, setCertificateImg] = useState('');
  const [passQRImg, setPassQRImg] = useState('');
  const [instantPassData, setInstantPassData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [deleteID, setDeleteID] = useState('');
  const [edit, setEdit] = useState(false);

  let ocmList = [
    { id: '', pass_type: '1', name: 'Presenter' },
    { id: '', pass_type: '2', name: 'Listener' },
    { id: '', pass_type: '3', name: 'Committee Members' },
  ];

  const fetchInstantPass = async () => {
    const response = await dispatch(fetchInstantPassData(eventId));
    if (response?.status === 200) {
      setInstantPassData(response?.data || []);
      setIsLoading(false);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    fetchInstantPass();
  }, [eventId]);

  const handleEditTemplateData = (data) => {
    setEdit(true);
    setHtmlContentData(data?.pass_html);
    setCertificateImg(data?.pass_background_file);
    setPassQRImg(data?.pass_qr_img);
  };

  const handleView = async (data) => {
    const { pass_preview_file } = data;
    const s3File = await generatePreSignedUrl(pass_preview_file, passPreview);
    setViewSample(`${s3File}`);
  };

  const handleDelete = (data) => {
    setDeleteID(data);
  };

  return (
    <>
      {deleteID && (
        <DeletePopup
          title="Delete Pass"
          message="Are you sure you want to delete this pass?"
          onHide={() => {
            setDeleteID('');
          }}
          handelSuccess={() => {
            fetchInstantPass();
            setDeleteID('');
          }}
          handelDelete={async () => {
            let findVal = ocmList?.find((o) => o.name === deleteID);
            let payload = {
              event_id: eventId,
              pass_type: findVal?.pass_type,
            };
            let forData = objectToFormData(payload);
            const response = await dispatch(deleteEventPass(forData));
            return response;
          }}
        />
      )}

      {instantPassPopup?.show && (
        <InstantPassPopup
          onHide={() => {
            setInstantPassPopup({
              show: false,
            });
          }}
          handleAPI={async (value, htmlContent, bgImg, qrImg) => {
            const payload = {
              event_id: eventId,
              pass_type: instantPassPopup?.pass_type,
              pass_html: value,
              pass_dummy_html: htmlContent,
              pass_background_file: bgImg,
              pass_qr_img: qrImg,
              type: edit ? 2 : 1,
            };
            return await dispatch(handleEventPass(objectToFormData(payload)));
          }}
          handleSuccess={() => {
            fetchInstantPass();
            dispatch(showSuccess('Event Pass Updated Successfully.'));
            setInstantPassPopup({
              show: false,
            });
          }}
          setHtmlContentData={setHtmlContentData}
          htmlContentData={htmlContentData}
          certificateImg={certificateImg}
          passQRImg={passQRImg}
          instantPassData={instantPassData}
        />
      )}

      <div className="cmb-10">
        <div>
          {ocmList.map((elm, index) => {
            const { id, pass_type, name } = elm;
            const findData = instantPassData?.find((o) => {
              let rVal = null;

              if (o.pass_type === pass_type) {
                return o;
              }
              return rVal;
            });

            let isExist = findData?.id ? true : false;

            return (
              <React.Fragment key={index}>
                <Card className="cmb-20 p-3 unset-br d-flex justify-content-between align-items-center">
                  <div className="text-15-500">{name}</div>
                  <div className="d-flex gap-3">
                    {isExist ? (
                      <>
                        {/* {viewAccess === '1' && ( */}
                        <Button
                          btnStyle="primary-outline"
                          className="h-35 text-14-400"
                          onClick={() => {
                            handleView(findData);
                          }}
                          rightIcon={<i className="bi bi-eye" />}
                        />
                        {/* )} */}
                        {/* {updateAccess === '1' && ( */}
                        <Button
                          btnStyle="primary-outline"
                          className="h-35 text-14-400"
                          onClick={() => {
                            setInstantPassPopup((prev) => {
                              return {
                                ...prev,
                                show: true,
                                sub_type: id,
                                pass_type: pass_type,
                              };
                            });
                            handleEditTemplateData(findData);
                          }}
                          rightIcon={<i className="bi bi-pencil-square" />}
                        />
                        {/* )} */}
                        {/* {deleteAccess === '1' && ( */}
                        <Button
                          btnStyle="delete-outline"
                          className="h-35 text-14-400"
                          onClick={() => {
                            handleDelete(name);
                          }}
                          rightIcon={<i className="bi bi-trash" />}
                        />
                        {/* )} */}
                      </>
                    ) : (
                      <>
                        {/* {createAccess === '1' && ( */}
                        <Button
                          btnStyle="primary-outline"
                          className="h-35 text-14-400"
                          text="Upload Certificate"
                          onClick={() => {
                            setEdit(false);
                            setHtmlContentData('');
                            setInstantPassPopup((prev) => {
                              return {
                                ...prev,
                                show: true,
                                sub_type: id,
                                pass_type: pass_type,
                              };
                            });
                          }}
                          rightIcon={<i className="bi bi-upload ms-2" />}
                        />
                        {/* )} */}
                      </>
                    )}
                  </div>
                </Card>
              </React.Fragment>
            );
          })}
        </div>
      </div>

      {viewSample && (
        <Modal
          fullscreen
          largeClose
          onHide={() => {
            setViewSample('');
          }}
        >
          <iframe
            frameBorder="0"
            className=""
            src={`${viewSample}#toolbar=0&navpanes=0`}
            title="description"
            style={{
              width: '100%',
              height: '99%',
            }}
          />
        </Modal>
      )}
    </>
  );
};

export default InstantPass;
